import { Hooks } from '@firmable/utilities';
import { useSearchParams } from 'next/navigation';
import React from 'react';

function StoreChromeExtensionQueryParams() {
  const searchParams = useSearchParams();

  const { setValue, removeValue } = Hooks.useBrowserExtensionLoginParams();

  React.useEffect(() => {
    const action = searchParams.get('action');

    if (!!action) {
      if (action === 'browser-extension-login') {
        setValue(Number(searchParams.get('tabId')));
      } else {
        removeValue();
      }
    }
  }, [searchParams, setValue, removeValue]);

  return null;
}

export { StoreChromeExtensionQueryParams };
